import { Typography, Card, CardContent, Box } from "@mui/material";


const PageContacts = () => {
    return (
        <Card>
            <CardContent>
                <Box>
                    <Typography align='center' variant="h4" sx={{ mb: 2 }}>
                        Контактная информация
                    </Typography>

                    <Box sx={{
                        width: '320px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    }}>
                      

                        <Typography >
                            ИП Герасименко Николай Николаевич
                        </Typography>

                        <Typography >
                        Регистрационный номер: ИП-01-2026-299
                        </Typography>

                        <Typography mb={2}>
                        ИНН: 9000091261
                        </Typography>

                        <Typography >
                        Адрес:
                        </Typography>
                        <Typography >
                            г. Тирасполь
                        </Typography>
                        <Typography >
                            ул. Ленина, д. 10, кв. 5
                        </Typography>

                        <Typography >
                        Телефон: +37377918542
                        </Typography>

                        <Typography mb={2}>
                        Email: nik.gerasimenko1995@mail.ru
                        </Typography>

                        <Typography >
                        Telegram: @coingold_support
                        </Typography>
                    </Box>

                </Box>
            </CardContent>
        </Card>
    )
}

export default PageContacts;

